export default __webpack_public_path__ + "static/media/cuerpo-mujer-piel-amarilla.375c1477.png";